import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import HelpHub from "./HelpHub";
import CategoryForm from "./CategoryForm";
import type { HelpCategoryId } from "./helpCategories";

function ContactUs() {
  const { t } = useTranslation();
  const [categoryId, setCategoryId] = useState<HelpCategoryId | null>(null);

  const handleSelect = useCallback((id: HelpCategoryId) => {
    setCategoryId(id);
  }, []);

  const handleBack = useCallback(() => {
    setCategoryId(null);
  }, []);

  return (
    <main
      className="page-content contact-us-page pb-5"
      aria-label={t("help.pageAria")}
    >
      {categoryId ? (
        <CategoryForm categoryId={categoryId} onBack={handleBack} />
      ) : (
        <HelpHub onSelect={handleSelect} />
      )}
    </main>
  );
}

ContactUs.displayName = "ContactUs";

export default memo(ContactUs);
